































































import { computed, defineComponent } from "@vue/composition-api";
import { useRequest } from "@/helpers/hooks/useRequest";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import CompanyRank, {
  Props as CompanyRankProps
} from "../../Molecules/CompanyRank/index.vue";
import RankDiff from "../../Atom/RankDiff/index.vue";
import {
  getCompanyRank,
  getCompanyRankByBusinessCategory,
  getCompanyRanksByGraduateYear,
  getCompanyRanksByUniversity
} from "@/api";
import { useRouter } from "@/router";

export default defineComponent({
  name: "CompanyRanks",
  components: {
    Heading,
    CompanyRank,
    RankDiff
  },
  setup(_) {
    const router = useRouter();
    const [{ data: totalRank, loading: loadingTotalRank }] = useRequest(
      () => getCompanyRank(),
      {
        immediate: true
      }
    );

    const [
      {
        data: companyRankByBusinessCategory,
        loading: loadingCompanyRankByBusinessCategory
      }
    ] = useRequest(() => getCompanyRankByBusinessCategory(), {
      immediate: true
    });
    const [
      {
        data: companyRanksByGraduateYear,
        loading: loadingCompanyRanksByGraduateYear
      }
    ] = useRequest(() => getCompanyRanksByGraduateYear(), {
      immediate: true
    });

    const [
      {
        data: companyRanksByUniversity,
        loading: loadingCompanyRanksByUniversity
      }
    ] = useRequest(() => getCompanyRanksByUniversity(), {
      immediate: true
    });

    const companyRanks = computed<CompanyRankProps["companyRank"][]>(() => [
      {
        title: "総合",
        total: totalRank.value?.total,
        rank: totalRank.value?.rank,
        previousRank: totalRank.value?.previous_rank,
        loading: loadingTotalRank.value,
        to: {
          name: "RankingsFavorites"
        }
      },
      {
        title:
          companyRankByBusinessCategory.value?.business_category_name ||
          "- 業界",
        total: companyRankByBusinessCategory.value?.total,
        rank: companyRankByBusinessCategory.value?.rank,
        previousRank: companyRankByBusinessCategory.value?.previous_rank,
        loading: loadingCompanyRankByBusinessCategory.value,
        to: {
          name: "RankingsFavorites",
          query: {
            bcn: companyRankByBusinessCategory.value?.business_category_name
          }
        }
      },
      ...(Array.isArray(companyRanksByGraduateYear.value)
        ? companyRanksByGraduateYear.value.map(companyRankByGraduateYear => ({
            title: `${companyRankByGraduateYear.graduate_year}年卒`,
            total: companyRankByGraduateYear.total,
            rank: companyRankByGraduateYear.rank,
            previousRank: companyRankByGraduateYear.previous_rank,
            to: {
              name: "RankingsFavorites",
              query: {
                gy: `${companyRankByGraduateYear.graduate_year}`
              }
            }
          }))
        : new Array(3).fill({
            title: `- 年卒`,
            loading: loadingCompanyRanksByGraduateYear
          }))
    ]);

    const companyRanksForUniversity = computed(() => {
      if (
        companyRanksByUniversity.value &&
        Array.isArray(companyRanksByUniversity.value)
      ) {
        return companyRanksByUniversity.value.map(companyRankByUniversity => ({
          universityName: companyRankByUniversity.university_name,
          total: companyRankByUniversity.total,
          rank: companyRankByUniversity.rank,
          previousRank: companyRankByUniversity.previous_rank,
          to: {
            name: "RankingsFavorites",
            query: {
              uis: [companyRankByUniversity.university_id],
              uns: [companyRankByUniversity.university_name]
            }
          }
        }));
      } else {
        return Array.from({ length: 3 }, () => ({
          universityName: "- 大学",
          loading: loadingCompanyRanksByUniversity
        }));
      }
    });

    const handleClickRanksMore = () => {
      const ranksMoreRoute = router.resolve({
        name: "RankingsFavorites"
      });
      window.open(ranksMoreRoute.href, "_blank", "noopener");
    };

    return {
      companyRanks,
      companyRanksForUniversity,
      handleClickRanksMore
    };
  }
});
